var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "31px",
    viewBox: "0 0 46 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -12.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1923368,15 L10.4445993,15 L27.5567388,26.9368284 L44.1923368,15 Z M47.0689726,16.6282844 L28.1560421,30.1992066 C27.8115677,30.4463832 27.3486645,30.4494653 27.0009293,30.2068975 L8.06897259,17.0006284 L8.06897259,40 L47.0689726,40 L47.0689726,16.6282844 Z M5.06897259,14.9079336 L5,14.8598208 L5.06897259,14.7609445 L5.06897259,13 C5.06897259,12.4477153 5.51668784,12 6.06897259,12 L49.0689726,12 C49.6212573,12 50.0689726,12.4477153 50.0689726,13 L50.0689726,42 C50.0689726,42.5522847 49.6212573,43 49.0689726,43 L6.06897259,43 C5.51668784,43 5.06897259,42.5522847 5.06897259,42 L5.06897259,14.9079336 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.778bf8c7.svg";
export { ForwardRef as ReactComponent };